<template>
  <div>
    <CaseTab
      v-if="predmet_info != null"
      :predmet_info="predmet_info"
      :current_tab="'Case'"
    />
    <DataLoader :is_on="fetching" />
    <div class="case-predmet">
      <div class="case-opis-izvjesce">
        <div v-if="predmet_info.opis_predmeta != null" class="case-opis">
          {{ predmet_info.opis_predmeta }}
          <!-- <img class="more-dots" src="@/assets/img/more.svg" /> -->
        </div>
        <div class="case-izvjesce">
          <img class="doc-icon" src="@/assets/img/doc_icon.svg" />
          <div class="case-izvjesce-txt">{{ $t('cases_management.case.case_status_report') }}</div>
        </div>
      </div>
      <div class="case-predmet-breakwrap">
        <div class="case-predmet-left">
          <div class="case-folders-line">
            <div class="case-folders case-folders-spisi section spisi-prazni">
              <div class="section-title">
                {{ $t("page_2.page_2_1.box_1.title") }}
              </div>
              <div
                class="section-square kreiraj-spis"
                v-if="is_permission_inside('case.spis.create')"
                @click="goToPredmet('novi-spis')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="46"
                  height="44"
                  viewBox="0 0 46 44"
                >
                  <g>
                    <g>
                      <path
                        fill="#b8b8c1"
                        d="M39.943 11.447v.191h.305a5.783 5.783 0 0 1 5.777 5.776v20.81A5.783 5.783 0 0 1 40.248 44H5.778A5.783 5.783 0 0 1 0 38.225V5.736A5.783 5.783 0 0 1 5.777-.039h11.127A5.792 5.792 0 0 1 21.17 1.84l3.378 3.694c.08.087.193.137.311.137h9.308a5.783 5.783 0 0 1 5.777 5.776zM10.442 38.225v-20.81a5.783 5.783 0 0 1 5.777-5.777h22.088v-.191a4.146 4.146 0 0 0-4.142-4.14h-9.308a2.065 2.065 0 0 1-1.518-.67l-3.377-3.694a4.153 4.153 0 0 0-3.058-1.347H5.777a4.146 4.146 0 0 0-4.142 4.14v32.489a4.146 4.146 0 0 0 4.142 4.14H6.3a4.146 4.146 0 0 0 4.143-4.14zm5.777-24.952a4.146 4.146 0 0 0-4.142 4.14v20.812a5.76 5.76 0 0 1-1.753 4.14h29.924a4.146 4.146 0 0 0 4.142-4.14V17.414a4.146 4.146 0 0 0-4.142-4.14zm5.356 14.547c0-.452.366-.818.817-.818h5.024v-5.02a.818.818 0 0 1 1.635 0v5.02h5.023a.817.817 0 1 1 0 1.635h-5.023v5.022a.817.817 0 1 1-1.635 0v-5.022h-5.024a.818.818 0 0 1-.817-.817z"
                      />
                    </g>
                  </g>
                </svg>
                <div>{{ $t("page_2.page_2_1.box_1.add_new") }}</div>
              </div>
              <div
                class="section-square kreiraj-spis"
                v-if="!is_permission_inside('case.spis.read')"
              >
                <svg
                  width="47"
                  height="45"
                  viewBox="0 0 47 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.5 33.48L32.4558 23.4811"
                    stroke="#B8B8C1"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M32.5 33.5L22.5 23.5"
                    stroke="#B8B8C1"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M39.943 11.486V11.677H40.248C41.7795 11.6786 43.2478 12.2876 44.3308 13.3704C45.4139 14.4533 46.0231 15.9215 46.025 17.453V38.263C46.0231 39.7945 45.4139 41.2627 44.3308 42.3456C43.2478 43.4284 41.7795 44.0374 40.248 44.039H5.778C4.2465 44.0377 2.77807 43.4289 1.69486 42.3463C0.611646 41.2636 0.00211805 39.7955 0 38.264L0 5.775C0.00211756 4.24368 0.611508 2.77571 1.6945 1.69309C2.7775 0.610469 4.24568 0.00158732 5.777 0H16.904C17.7064 0.000599721 18.5 0.167934 19.2344 0.491392C19.9687 0.81485 20.6279 1.28737 21.17 1.879L24.548 5.573C24.628 5.66 24.741 5.71 24.859 5.71H34.167C35.6985 5.71159 37.1668 6.32061 38.2498 7.40344C39.3329 8.48628 39.9411 9.9545 39.943 11.486ZM10.442 38.264V17.454C10.4436 15.9223 11.0527 14.4539 12.1358 13.3708C13.2189 12.2877 14.6873 11.6786 16.219 11.677H38.307V11.486C38.3054 10.3881 37.8684 9.33574 37.092 8.55962C36.3155 7.78351 35.2629 7.34706 34.165 7.346H24.857C24.5714 7.34537 24.289 7.2855 24.0277 7.17018C23.7665 7.05485 23.5319 6.88658 23.339 6.676L19.962 2.982C19.5734 2.55794 19.1009 2.21925 18.5745 1.98737C18.048 1.7555 17.4792 1.63551 16.904 1.635H5.777C4.67914 1.63606 3.62653 2.07251 2.85004 2.84863C2.07355 3.62474 1.63659 4.67715 1.635 5.775V38.264C1.63659 39.3619 2.07355 40.4143 2.85004 41.1904C3.62653 41.9665 4.67914 42.4029 5.777 42.404H6.3C7.39803 42.4032 8.4509 41.9669 9.22761 41.1907C10.0043 40.4146 10.4404 39.362 10.442 38.264ZM16.219 13.312C15.1211 13.3131 14.0685 13.7495 13.292 14.5256C12.5155 15.3017 12.0786 16.3541 12.077 17.452V38.264C12.0773 39.0364 11.9223 39.8009 11.6211 40.5121C11.3199 41.2233 10.8788 41.8667 10.324 42.404H40.248C41.3459 42.4029 42.3985 41.9665 43.175 41.1904C43.9515 40.4143 44.3884 39.3619 44.39 38.264V17.453C44.3884 16.3551 43.9515 15.3027 43.175 14.5266C42.3985 13.7505 41.3459 13.3141 40.248 13.313L16.219 13.312Z"
                    fill="#B8B8C1"
                  />
                </svg>

                <div>{{ $t("page_2.page_2_1.box_1.no_auth") }}</div>
              </div>
              <router-link
                to="spisi"
                class="section-square spis-folder aktivan-spis-folder"
                v-if="is_permission_inside('case.spis.read')"
              >
                <div
                  :class="[
                    'zadnji-spis-dot',
                    'indikator',
                    !predmet_info.is_archived
                      ? 'i-g'
                      : predmet_info.is_archived && !predmet_info.is_destroyed
                      ? 'i-g-archived'
                      : 'i-g-destroyed',
                  ]"
                ></div>
                <svg
                  version="1.0"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 137 113.1"
                  style="enable-background: new 0 0 137 113.1"
                  xml:space="preserve"
                >
                  <path
                    class="st0"
                    d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                C127.9,106.8,124.5,109.7,120.2,109.7z"
                  />
                  <g>
                    <path
                      class="st1"
                      d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                  C126.3,106.8,122.8,110,118.4,110z"
                    />
                    <path
                      class="st0"
                      d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7l2.9,82.5
                  C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                  c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z"
                    />
                  </g>
                  <g>
                    <path
                      class="st1"
                      d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                  C109.6,95.1,106.2,98.4,101.9,98.4z"
                    />
                    <path
                      class="st0"
                      d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                  l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                  c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z"
                    />
                  </g>
                  <g>
                    <g>
                      <path
                        class="st2"
                        d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                    c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z"
                      />
                    </g>
                  </g>
                </svg>
                <div v-if="rootSpisi[0] && rootSpisi[0].ime">
                  {{ rootSpisi[0].ime }}
                </div>
              </router-link>
              <router-link
                to="spisi"
                class="case-spisi-sve pogledaj-sve"
                v-if="is_permission_inside('case.spis.read')"
              >
                {{ $t("page_2.page_2_1.box_1.all_btn") }}</router-link
              >
            </div>
            <!-- Close case-folders-spisi -->
            <div class="case-folders case-folders-dokumentacija section">
              <div class="section-title">
                {{ $t("page_2.page_2_1.box_2.title") }}
              </div>
              <div class="case-spisi-folders-line">
                <div
                  class="section-square kreiraj-spis"
                  v-if="!is_permission_inside('case.radni.read', false)"
                >
                  <svg
                    width="47"
                    height="45"
                    viewBox="0 0 47 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.5 33.48L32.4558 23.4811"
                      stroke="#B8B8C1"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M32.5 33.5L22.5 23.5"
                      stroke="#B8B8C1"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M39.943 11.486V11.677H40.248C41.7795 11.6786 43.2478 12.2876 44.3308 13.3704C45.4139 14.4533 46.0231 15.9215 46.025 17.453V38.263C46.0231 39.7945 45.4139 41.2627 44.3308 42.3456C43.2478 43.4284 41.7795 44.0374 40.248 44.039H5.778C4.2465 44.0377 2.77807 43.4289 1.69486 42.3463C0.611646 41.2636 0.00211805 39.7955 0 38.264L0 5.775C0.00211756 4.24368 0.611508 2.77571 1.6945 1.69309C2.7775 0.610469 4.24568 0.00158732 5.777 0H16.904C17.7064 0.000599721 18.5 0.167934 19.2344 0.491392C19.9687 0.81485 20.6279 1.28737 21.17 1.879L24.548 5.573C24.628 5.66 24.741 5.71 24.859 5.71H34.167C35.6985 5.71159 37.1668 6.32061 38.2498 7.40344C39.3329 8.48628 39.9411 9.9545 39.943 11.486ZM10.442 38.264V17.454C10.4436 15.9223 11.0527 14.4539 12.1358 13.3708C13.2189 12.2877 14.6873 11.6786 16.219 11.677H38.307V11.486C38.3054 10.3881 37.8684 9.33574 37.092 8.55962C36.3155 7.78351 35.2629 7.34706 34.165 7.346H24.857C24.5714 7.34537 24.289 7.2855 24.0277 7.17018C23.7665 7.05485 23.5319 6.88658 23.339 6.676L19.962 2.982C19.5734 2.55794 19.1009 2.21925 18.5745 1.98737C18.048 1.7555 17.4792 1.63551 16.904 1.635H5.777C4.67914 1.63606 3.62653 2.07251 2.85004 2.84863C2.07355 3.62474 1.63659 4.67715 1.635 5.775V38.264C1.63659 39.3619 2.07355 40.4143 2.85004 41.1904C3.62653 41.9665 4.67914 42.4029 5.777 42.404H6.3C7.39803 42.4032 8.4509 41.9669 9.22761 41.1907C10.0043 40.4146 10.4404 39.362 10.442 38.264ZM16.219 13.312C15.1211 13.3131 14.0685 13.7495 13.292 14.5256C12.5155 15.3017 12.0786 16.3541 12.077 17.452V38.264C12.0773 39.0364 11.9223 39.8009 11.6211 40.5121C11.3199 41.2233 10.8788 41.8667 10.324 42.404H40.248C41.3459 42.4029 42.3985 41.9665 43.175 41.1904C43.9515 40.4143 44.3884 39.3619 44.39 38.264V17.453C44.3884 16.3551 43.9515 15.3027 43.175 14.5266C42.3985 13.7505 41.3459 13.3141 40.248 13.313L16.219 13.312Z"
                      fill="#B8B8C1"
                    />
                  </svg>

                  <div>Nemate ovlasti pregleda dokumentacije</div>
                </div>
                <div
                  class="section-square radni-dokumenti"
                  v-if="is_permission_inside('case.radni.read', false)"
                  @click="goToPredmet('radni')"
                >
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 137 113.1"
                    enable-background="new 0 0 137 113.1"
                    xml:space="preserve"
                  >
                    <path
                      fill="#E5E9F4"
                      d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                  C127.9,106.8,124.5,109.7,120.2,109.7z"
                    />
                    <g>
                      <path
                        fill="#FFFFFF"
                        d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                    C126.3,106.8,122.8,110,118.4,110z"
                      />
                      <path
                        fill="#E5E9F4"
                        d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7
                    l2.9,82.5C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                    c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z"
                      />
                    </g>
                    <g>
                      <path
                        fill="#FFFFFF"
                        d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                    C109.6,95.1,106.2,98.4,101.9,98.4z"
                      />
                      <path
                        fill="#E5E9F4"
                        d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                    l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                    c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z"
                      />
                    </g>
                    <g>
                      <g>
                        <path
                          fill="#E9A422"
                          d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                      c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z"
                        />
                      </g>
                    </g>
                  </svg>
                  <div>{{ $t("page_2.page_2_1.box_2.fold_1") }}</div>
                </div>
                <div
                  class="section-square popratna-dokumentacija"
                  v-if="is_permission_inside('case.side.read', false)"
                  @click="goToPredmet('popratni')"
                >
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 137 113.1"
                    enable-background="new 0 0 137 113.1"
                    xml:space="preserve"
                  >
                    <path
                      fill="#E4E8F3"
                      d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                  C127.9,106.8,124.5,109.7,120.2,109.7z"
                    />
                    <g>
                      <path
                        fill="#FFFFFF"
                        d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                    C126.3,106.8,122.8,110,118.4,110z"
                      />
                      <path
                        fill="#E4E8F3"
                        d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7
                    l2.9,82.5C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                    c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z"
                      />
                    </g>
                    <g>
                      <path
                        fill="#FFFFFF"
                        d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                    C109.6,95.1,106.2,98.4,101.9,98.4z"
                      />
                      <path
                        fill="#E4E8F3"
                        d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                    l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                    c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z"
                      />
                    </g>
                    <g>
                      <g>
                        <path
                          fill="#7E48B7"
                          d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                      c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z"
                        />
                      </g>
                    </g>
                  </svg>
                  <div>{{ $t("page_2.page_2_1.box_2.fold_2") }}</div>
                </div>
              </div>
            </div>
            <!-- Close case-folders-dokumentacija -->
          </div>
          <HomepageComunication
            v-if="is_permission_inside('case.comunication.move', false)"
            :ulazni_id="predmet_info.root_ulazna"
            :permission="is_permission_inside('case.comunication.create')"
          />
          <div
            :class="[
              'case-napomene',
              'case-aktivnost',
              'section',
              napomene.length == 0 ? 'napomene-prazne' : '',
            ]"
          >
            <div class="section-title napomene-title">
              {{ $t("page_2.page_2_1.box_6.title") }}
            </div>
            <div
              @click="new_napomena_open = true"
              v-if="is_permission_inside('case.edit')"
              class="section-square kreiraj-spis"
            >
              <div>{{ $t("page_2.page_2_1.box_6.add_new") }}</div>
            </div>
            <div
              v-if="napomene.length > 0 && is_permission_inside('case.edit')"
              @click="new_napomena_open = true"
              class="add-napomena add-button add-plus"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
              >
                <g>
                  <g>
                    <path
                      fill="#0acab1"
                      d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="case-napomene-wrapper">
              <div
                v-for="(na, key) in finalni_arr_prikaza"
                :key="key"
                class="case-napomena"
              >
                <div class="case-napomena-datum">
                  {{ switchDate(na.napravljeno) }}
                </div>
                <div class="case-napomena-txt-autor">
                  <div class="case-napomena-txt">
                    {{ na.tekst }}
                  </div>
                  <div class="case-napomena-autor">
                    {{ na.odvjetnik.ime }} {{ na.odvjetnik.prezime }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagin-wrapp page-nav" v-if="all_pages.length > 1">
              <div
                class="page-nav-prev"
                v-if="!isFirstPage"
                @click="setPage(curr_page - 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1018")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          <path
                            class="sssdr"
                            d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div
                  :class="{ 'curr-page': curr_page == 1 }"
                  @click="setPage(1)"
                >
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible">
                <div>...</div>
              </div>
              <div
                class="page-nav-no"
                v-for="(str, key) in getLeftRightPages"
                :key="key"
                @click="setPage(str)"
              >
                <div :class="{ 'curr-page': curr_page == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible">
                <div>...</div>
              </div>
              <div class="page-nav-no" v-if="all_pages.length > 1">
                <div
                  :class="{ 'curr-page': curr_page == all_pages.length }"
                  @click="setPage(all_pages.length)"
                >
                  {{ all_pages.length }}
                </div>
              </div>
              <div
                class="page-nav-next"
                v-if="!isLastPage"
                @click="setPage(curr_page + 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1043")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path
                            class="sssdr"
                            d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div
            :class="[
              'case-napomene',
              'case-aktivnost',
              'section',
              notes.length == 0 ? 'napomene-prazne' : '',
            ]"
          >
            <div class="section-title napomene-title">
              {{ $t("page_2.page_2_1.box_8.title") }}
            </div>
            <div
              @click="new_notes_open = true"
              v-if="is_permission_inside('case.edit')"
              class="section-square kreiraj-spis"
            >
              <div>{{ $t("page_2.page_2_1.box_8.add_new") }}</div>
            </div>
            <div
              v-if="notes.length > 0 && is_permission_inside('case.edit')"
              @click="new_notes_open = true"
              class="add-napomena add-button add-plus"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
              >
                <g>
                  <g>
                    <path
                      fill="#0acab1"
                      d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="case-napomene-wrapper">
              <div
                v-for="(na, key) in finalni_arr_prikaza_notes"
                :key="key"
                class="case-napomena"
              >
                <div class="case-napomena-datum">
                  {{ switchDate(na.edited_datetime) }}<br />{{
                    getTime(na.edited_datetime)
                  }}
                </div>
                <div class="case-napomena-txt-autor">
                  <div class="case-napomena-txt">
                    {{ na.details }}
                  </div>
                  <div class="case-napomena-autor">
                    {{ na.odvjetnik.ime }} {{ na.odvjetnik.prezime }}
                    {{
                      na.created_by != na.edited_by &&
                      odvjetnici.find((o) => o.odvjetnik.uid == na.edited_by)
                        ? `(Uredio:
                                      ${getOdvjetnik(na.edited_by)})`
                        : ""
                    }}
                  </div>
                </div>
                <div
                  class="add-napomena add-button remove-item"
                  @click="deleteNote(na)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                  >
                    <g>
                      <g>
                        <path
                          fill="#70707E"
                          d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div @click="setEdit(na)" class="edit-info add-button add-pen">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                  >
                    <g>
                      <g>
                        <path
                          fill="#7b7b8a"
                          d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="pagin-wrapp page-nav" v-if="all_pages_notes.length > 1">
              <div
                class="page-nav-prev"
                v-if="!isFirstPageNotes"
                @click="setPageNotes(curr_page_notes - 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1018")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          <path
                            class="sssdr"
                            d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div
                  :class="{ 'curr-page': curr_page_notes == 1 }"
                  @click="setPageNotes(1)"
                >
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible_notes">
                <div>...</div>
              </div>
              <div
                class="page-nav-no"
                v-for="(str, key) in getLeftRightPagesNotes"
                :key="key"
                @click="setPageNotes(str)"
              >
                <div :class="{ 'curr-page': curr_page_notes == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible_notes">
                <div>...</div>
              </div>
              <div class="page-nav-no" v-if="all_pages_notes.length > 1">
                <div
                  :class="{
                    'curr-page': curr_page_notes == all_pages_notes.length,
                  }"
                  @click="setPageNotes(all_pages_notes.length)"
                >
                  {{ all_pages_notes.length }}
                </div>
              </div>
              <div
                class="page-nav-next"
                v-if="!isLastPageNotes"
                @click="setPageNotes(curr_page_notes + 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1043")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path
                            class="sssdr"
                            d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <!-- Close case-napomene -->
          <QNATableVue v-if="case_qa.length > 0" :qa_table="case_qa" :key="case_qa.length"></QNATableVue>

        </div>
        <!-- Close case-predmet-left -->
        <div class="case-predmet-right-leftpt">
          <div class="case-info section">
            <div class="section-title">
              {{ $t("page_2.page_2_1.box_3.title") }}
            </div>
            <div
              v-if="is_permission_inside('case.edit')"
              @click="goToPredmet('edit')"
              class="edit-info add-button add-pen"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
              >
                <g>
                  <g>
                    <path
                      fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_1") }}:
              </div>
              <div class="case-info-item-info">
                {{ predmet_info.broj_predmeta }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_2") }}:
              </div>
              <div class="case-info-item-info">
                <span>{{ getSpisPbr }}</span>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_3") }}
              </div>
              <div class="case-info-item-info">
                {{
                  predmet_info.VPS != null
                    ? predmet_info.VPS.toFixed(2)
                        .toString()
                        .replaceAll(".", ",")
                        .replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g, "$1.")
                    : null
                }}
                {{
                  predmet_info.VPS != null
                    ? predmet_info.currency.short_name
                    : ""
                }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_4") }}:
              </div>
              <div class="case-info-item-info">
                <router-link
                  v-if="odvjetnik_nositelj != null"
                  :to="'/osobe/law/' + odvjetnik_nositelj.odvjetnik.uid"
                  >{{ odvjetnik_nositelj.odvjetnik.ime }}
                  {{ odvjetnik_nositelj.odvjetnik.prezime }}</router-link
                >
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_5") }}:
              </div>
              <div class="case-info-item-info">
                <a
                  href="#"
                  v-if="prav_stranke.length == 0 && fiz_stranke.length == 0"
                  >N/A</a
                >
                <router-link
                  v-for="leg_singl in prav_stranke"
                  :key="leg_singl.uid"
                  :to="'/osobe/prav/' + leg_singl.pravna_osoba.uid"
                  >{{ leg_singl.pravna_osoba.ime }}
                </router-link>
                <router-link
                  v-for="fiz_singl in fiz_stranke"
                  :key="fiz_singl.uid"
                  :to="'/osobe/fiz/' + fiz_singl.fizicka_osoba.uid"
                  >{{ fiz_singl.fizicka_osoba.ime }}
                  {{ fiz_singl.fizicka_osoba.prezime }}</router-link
                >
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_6") }}:
              </div>
              <div class="case-info-item-info">
                <a
                  href="#"
                  v-if="
                    prav_protustranke.length == 0 &&
                    fiz_protustranke.length == 0
                  "
                  >N/A</a
                >
                <router-link
                  :to="'/osobe/prav/' + prav_protustranke[0].pravna_osoba.uid"
                  v-if="prav_protustranke.length > 0"
                  >{{ prav_protustranke[0].pravna_osoba.ime }}
                  {{ prav_protustranke[0].pravna_osoba.prezime }}</router-link
                >
                <router-link
                  :to="'/osobe/fiz/' + fiz_protustranke[0].fizicka_osoba.uid"
                  v-if="fiz_protustranke.length > 0"
                  >{{ fiz_protustranke[0].fizicka_osoba.ime }}
                  {{ fiz_protustranke[0].fizicka_osoba.prezime }}</router-link
                >
                <span class="role"></span>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">
                {{ $t("page_2.page_2_1.box_3.lt_7") }}:
              </div>
              <div class="case-info-item-info">
                <span class="green">{{ getSpisCaseType }}</span>
                <!-- <span class="secondary">Ovršni postupak</span>
                <span class="secondary">Parnični postupak</span> -->
              </div>
            </div>
          </div>
          <div class="case-team section">
            <div class="section-title">
              {{ $t("page_2.page_2_1.box_5.title") }}
            </div>
            <div
              class="edit-case-team add-button add-pen"
              style="display: none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
              >
                <g>
                  <g>
                    <path
                      fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div
              class="case-team-member"
              v-for="(odvjetnik, idx) in odvjetnici"
              :key="idx"
            >
            <!-- {{ odvjetnik.odvjetnik.ime }} {{ odvjetnik.odvjetnik.prezime }} -->
              <!-- <router-link :to="'/osobe/law/' + odvjetnik.oib"> -->
              <div
                class="case-team-member-img"
                :style="odvjetnik.avatar_style"
              >
                <div class="case-team-initials-circle" v-if="odvjetnik.avatar_style == null">{{ odvjetnik.odvjetnik.ime.split(" ")[0][0] + odvjetnik.odvjetnik.prezime.split(" ")[0][0] }}</div>
              </div>
              <div class="case-team-member-txt">
                <router-link :to="'/osobe/law/' + odvjetnik.odvjetnik.uid">
                  {{ odvjetnik.odvjetnik.ime }}
                  {{ odvjetnik.odvjetnik.prezime }}</router-link
                >
                <span class="role">{{
                  odvjetnik.status_odvjetnik_predmet.naziv
                }}</span>
              </div>
              <!-- </router-link> -->
            </div>
            <!-- <div class="case-team-member">
              <div class="case-team-member-img case-team-member2"></div>
              <div class="case-team-member-txt">Maja Kauzler - Geček<span class="role">Odvjetnik</span></div>
            </div>
            <div class="case-team-member">
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-team-member-txt">Dmitar Tar<span class="role">Vježbenik</span></div>
            </div>-->
          </div>
          <!-- end case team section -->
          <div class="case-aktivnost section">
            <div class="section-title">
              {{ $t("page_2.page_2_1.box_7.title") }}
            </div>
            <div
              class="case-aktivnost-clan"
              v-for="(nm, key) in final_activities"
              :key="key"
            >
              <div class="aktivnost-dot indikator i-g"></div>
              <div class="case-aktivnost-txts">
                <div class="case-aktivnost-txt">
                  <b>{{ nm.odvjetnik.ime }} {{ nm.odvjetnik.prezime }}</b>
                </div>
                <div class="case-aktivnost-txt case-aktivnost-wide">
                  {{ nm.log_text }}
                </div>
                <div class="case-aktivnost-txt">
                  <span>{{ logStamp(nm.timestamp) }} </span>
                </div>
              </div>
            </div>
            <div class="pagin-wrapp page-nav" v-if="all_pages_act.length > 1">
              <div
                class="page-nav-prev"
                v-if="!isFirstPageAct"
                @click="setPageActivity(curr_page_act - 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1018")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          <path
                            class="sssdr"
                            d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div
                  :class="{ 'curr-page': curr_page_act == 1 }"
                  @click="setPageActivity(1)"
                >
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible_act">
                <div>...</div>
              </div>
              <div
                class="page-nav-no"
                v-for="(str, key) in getLeftRightPagesAct"
                :key="key"
                @click="setPageActivity(str)"
              >
                <div :class="{ 'curr-page': curr_page_act == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible_act">
                <div>...</div>
              </div>
              <div class="page-nav-no" v-if="all_pages_act.length > 1">
                <div
                  :class="{
                    'curr-page': curr_page_act == all_pages_act.length,
                  }"
                  @click="setPageActivity(all_pages_act.length)"
                >
                  {{ all_pages_act.length }}
                </div>
              </div>
              <div
                class="page-nav-next"
                v-if="!isLastPageAct"
                @click="setPageActivity(curr_page_act + 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1043")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path
                            class="sssdr"
                            d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <!-- end case aktivnost section -->
          <!-- <div class="case-team section">
            <div class="section-title">Pravni dužnosnici</div>
             <div class="edit-case-team add-button add-pen">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
              >
                <g>
                  <g>
                    <path
                      fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div
              class="case-team-member"
              v-for="(sluzbena_osoba, idx) in sluzbene_osobe"
              :key="idx"
            >
              <router-link :to="'/osobe/law/' + odvjetnik.oib">
              <div class="case-team-member-img case-team-member1"></div>
              <div class="case-team-member-txt">
                {{ sluzbena_osoba.sluzbena_osoba.ime }}
                {{ sluzbena_osoba.sluzbena_osoba.prezime
                }}<span class="role">{{
                  sluzbena_osoba.sluzbena_uloga.uloga_name
                }}</span>
              </div>
              </router-link> 
            </div>
            <div class="case-team-member">
              <div class="case-team-member-img case-team-member2"></div>
              <div class="case-team-member-txt">Maja Kauzler - Geček<span class="role">Odvjetnik</span></div>
            </div>
            <div class="case-team-member">
              <div class="case-team-member-img case-team-member3"></div>
              <div class="case-team-member-txt">Dmitar Tar<span class="role">Vježbenik</span></div>
            </div>
          </div> -->
          <div class="case-zadaci section zadaci-prazni" style="display: none">
            <div class="section-title zadaci-title">
              Zadaci<span class="zadaci-amount">1</span>
            </div>
            <div class="add-zadatak add-button add-plus">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
              >
                <g>
                  <g>
                    <path
                      fill="#0acab1"
                      d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="zadatak">
              <!-- <div class="zadatak-datum">27.1.2021</div>
              <div class="zadatak-naziv-autor">
                <div class="zadatak-naziv">Priprema materijala za ročište</div>
                <div class="zadatak-autor">Marko M.</div>
              </div> -->
              <div class="zadaci-furher-arrow furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="zadatak">
              <div class="zadatak-datum">31.1.2021</div>
              <div class="zadatak-naziv-autor">
                <div class="zadatak-naziv">
                  Naplata potraživanja za xyz d.o.o.
                </div>
                <div class="zadatak-autor">Maja K.</div>
              </div>
              <div class="zadaci-furher-arrow furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="zadatak">
              <div class="zadatak-datum">02.02.2021</div>
              <div class="zadatak-naziv-autor">
                <div class="zadatak-naziv">
                  Potrebno zavesti nove sudionike...
                </div>
                <div class="zadatak-autor">Maja K.</div>
              </div>
              <div class="zadaci-furher-arrow furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="zadatak">
              <div class="zadatak-datum">18.02.2021</div>
              <div class="zadatak-naziv-autor">
                <div class="zadatak-naziv">
                  Provjera papirologije vezane za...
                </div>
                <div class="zadatak-autor">Maja K.</div>
              </div>
              <div class="zadaci-furher-arrow furher-arrow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="17"
                  viewBox="0 0 10 17"
                >
                  <g>
                    <g>
                      <path
                        fill="#9595ad"
                        d="M9.606 9.121l-8.233 7.66a.684.684 0 0 1-.979 0 .71.71 0 0 1 0-.994l7.737-7.198L.394 1.391a.71.71 0 0 1 0-.994.684.684 0 0 1 .979 0l8.233 7.66a.7.7 0 0 1 .196.532.7.7 0 0 1-.196.532z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="section-square kreiraj-spis">
              <div>Dodaj zadatak</div>
            </div>
            <div class="zadaci-svi pogledaj-sve">pogledaj sve</div>
          </div>
        </div>
        <!-- Close case-predmet-right-leftpt -->
      </div>
      <!-- Close case-predmet-breakwrap -->
      <div class="case-predmet-right-rightpt">
        <MiniCalendar
          :is_a_moron="is_permission_inside('case.calendar.read')"
        />
      </div>
      <!-- Close case-predmet-right-rightpt -->
    </div>
    <!-- Close case-predmet -->
    <v-dialog v-model="new_napomena_open" width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("page_2.page_2_1.box_6.popup.title") }}
        </div>
        <v-text-field
          class="universal-vdialog-textfield"
          :label="$t('page_2.page_2_1.box_6.popup.placeholder')"
          v-model="napomena.napomena_text"
        ></v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="new_napomena_open = false"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="addNapomena()"
          >
            {{ $t("page_2.page_2_1.box_6.popup.add_btn") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="new_notes_open" persistent width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{
            !is_edit_mode
              ? $t("page_2.page_2_1.box_8.popup.title")
              : $t("page_2.page_2_1.box_8.popup.title_edit")
          }}
        </div>
        <v-text-field
          class="universal-vdialog-textfield"
          :label="
            !is_edit_mode
              ? $t('page_2.page_2_1.box_8.popup.placeholder')
              : $t('page_2.page_2_1.box_8.popup.placeholder_edit')
          "
          v-model="note.note_text"
        ></v-text-field>
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="resetNoteDetails()"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="!is_edit_mode ? addNote() : editNote()"
          >
            {{ $t("page_2.page_2_1.box_8.popup.add_btn") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_warning" persistent width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("page_2.page_2_1.box_8.delete_popup.title") }}
        </div>
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="
              temp_note = null;
              delete_warning = false;
            "
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="deleteNoteDb()"
          >
            {{ $t("page_2.page_2_1.box_8.delete_popup.delete_btn") }}
          </div>
        </div>
      </v-card>
    </v-dialog>

    <div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import moment from "moment";
import share from "@/apiCallers/promise_handler_db/sharepoint";
import Spisi from "@/components/caseComponents/Spisi.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import MiniCalendar from "@/components/calendarComponents/MiniCalendar.vue";
import HomepageComunication from "@/components/caseComponents/HomepageComunication.vue";
import person from "@/apiCallers/promise_handler_db/person";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import permissioner from "@/services/permissioner.js";
import { getCaseData } from "@/router/case/handler";
import DataLoader from "@/components/generalComponents/DataLoader.vue";
import QNATableVue from "@/components/caseComponents/QNATable.vue";
import avatarService from "@/services/avatarService";

export default {
  components: {
    Spisi,
    CaseTab,
    MiniCalendar,
    HomepageComunication,
    DataLoader,
    QNATableVue
  },
  data() {
    return {
      selectedTab: "Opis",
      accessToken: "",
      rootSpisi: [],
      calendar_data: { rasporedi_liste: [[], [], []] },
      group: {},
      owners: [],
      members: [],
      goranDocuments: [],
      files: [],
      predmet_info: { ime_predmeta: "" },
      odvjetnik_nositelj: null,
      fiz_stranke: [],
      prav_stranke: [],
      fiz_protustranke: [],
      prav_protustranke: [],
      odvjetnici: [],
      nadlezna_tijela: [],
      institucije: [],
      napomene: [],
      notes: [],
      sluzbene_osobe: [],
      case_log: [],

      mapped_case_permission: [],
      case_qa : [],

      new_napomena_open: false,
      new_notes_open: false,
      current_napomena_text: "",
      mjeseci: {
        1: "Siječanj",
        2: "Veljača",
        3: "Ožujak",
        4: "Travanj",
        5: "Svibanj",
        6: "Lipanj",
        7: "Srpanj",
        8: "Kolovoz",
        9: "Rujan",
        10: "Listopad",
        11: "Studeni",
        12: "Prosinac",
      },
      napomena: {
        unio: "",
        napomena_text: "",
      },
      note: {
        unio: "",
        note_text: "",
      },
      curr_page: 1,
      br_redova: 3,
      all_pages: [],
      finalni_arr_prikaza: [],
      curr_page_notes: 1,
      br_redova_notes: 3,
      all_pages_notes: [],
      finalni_arr_prikaza_notes: [],
      curr_page_act: 1,
      br_redova_act: 3,
      all_pages_act: [],
      final_activities: [],
      permission: {
        create: true,
        update: true,
        delete: true,
        read: true,
      },
      left_dots_visible: false,
      right_dots_visible: false,
      left_dots_visible_notes: false,
      right_dots_visible_notes: false,
      left_dots_visible_act: false,
      right_dots_visible_act: false,
      temp_note: null,
      delete_warning: false,
      is_edit_mode: false,
      fetching: true,
    };
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
        // this.getGroupById();
      }
    },
    curr_page: function () {
      this.paginirajOdabrane();
    },
    curr_page_act: function () {
      this.paginirajOdabraneActivity();
    },
    curr_page_notes: function () {
      this.paginirajOdabraneNotes();
    },
  },
  computed: {
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    isFirstPageNotes() {
      return this.curr_page_notes == 1;
    },
    isLastPageNotes() {
      return (
        this.curr_page_notes ==
        this.all_pages_notes[this.all_pages_notes.length - 1]
      );
    },
    isFirstPageAct() {
      return this.curr_page_act == 1;
    },
    isLastPageAct() {
      return (
        this.curr_page_act == this.all_pages_act[this.all_pages_act.length - 1]
      );
    },
    getSpisCaseType() {
      if (this.rootSpisi.length > 0) {
        if (this.rootSpisi[0].postupak != null) {
          return this.rootSpisi[0].postupak.naziv;
        }
        return "N/A";
      } else return "N/A";
    },
    getSpisPbr() {
      if (this.rootSpisi.length > 0) {
        return this.rootSpisi[0].posl_br != null
          ? this.rootSpisi[0].posl_br
          : "N/A";
      } else return "N/A";
    },
    getLeftRightPagesAct() {
      // Init values
      let return_pages = [];
      this.right_dots_visible_act = false;
      this.left_dots_visible_act = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page_act;
      if (this.curr_page_act == this.all_pages_act.length)
        left_end = this.curr_page_act - 1;
      if (this.curr_page_act > 3) {
        left_start = this.curr_page_act - 1;
        this.left_dots_visible_act = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page_act + 1;
      if (right_start < this.all_pages_act.length)
        return_pages.push(right_start);
      if (right_start < this.all_pages_act.length - 1)
        this.right_dots_visible_act = true;
      return return_pages;
    },
    getLeftRightPages() {
      // Init values
      let return_pages = [];
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if (this.curr_page == this.all_pages.length)
        left_end = this.curr_page - 1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length) return_pages.push(right_start);
      if (right_start < this.all_pages.length - 1)
        this.right_dots_visible = true;
      return return_pages;
    },
    getLeftRightPagesNotes() {
      // Init values
      let return_pages = [];
      this.right_dots_visible_notes = false;
      this.left_dots_visible_notes = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page_notes;
      if (this.curr_page_notes == this.all_pages_notes.length)
        left_end = this.curr_page_notes - 1;
      if (this.curr_page_notes > 3) {
        left_start = this.curr_page_notes - 1;
        this.left_dots_visible_notes = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page_notes + 1;
      if (right_start < this.all_pages_notes.length)
        return_pages.push(right_start);
      if (right_start < this.all_pages_notes.length - 1)
        this.right_dots_visible_notes = true;
      return return_pages;
    },
  },
  methods: {
    is_permission_inside(wanted_permission, check_assistent = true) {
      return permissioner.check_case_permsision(
        wanted_permission,
        check_assistent
      );
    },

    logStamp(ts) {
      return moment(ts).format("lll");
    },
    calculatePageNumber() {
      this.all_pages = [];
      var finalni_broj = this.napomene.length / this.br_redova;
      if (this.napomene.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      if (this.all_pages.length != 0) {
        this.curr_page = 1;
      }
    },
    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.napomene.slice(start_idx, end_idx);
    },
    setPage(pg) {
      this.curr_page = pg;
    },
    setPageNotes(pg) {
      this.curr_page_notes = pg;
    },
    calculatePageNumberNotes() {
      this.all_pages_notes = [];
      var finalni_broj = this.notes.length / this.br_redova;
      if (this.notes.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages_notes.push(i);
      }
      if (this.all_pages_notes.length != 0) {
        this.curr_page_notes = 1;
      }
    },
    paginirajOdabraneNotes() {
      let start_idx = 0 + this.br_redova * (this.curr_page_notes - 1);
      let end_idx = this.br_redova * this.curr_page_notes;

      this.finalni_arr_prikaza_notes = this.notes.slice(start_idx, end_idx);
    },
    calculatePageNumberActivity() {
      this.all_pages_act = [];
      var finalni_broj = this.case_log.length / this.br_redova_act;
      if (this.case_log.length % this.br_redova_act >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages_act.push(i);
      }
      if (this.all_pages_act.length != 0) {
        this.curr_page_act = 1;
      }
    },
    paginirajOdabraneActivity() {
      let start_idx = 0 + this.br_redova_act * (this.curr_page_act - 1);
      let end_idx = this.br_redova_act * this.curr_page_act;

      this.final_activities = this.case_log.slice(start_idx, end_idx);
    },
    setPageActivity(pg) {
      this.curr_page_act = pg;
    },
    switchDate(inData) {
      return moment(inData.toString()).format("LL");
    },
    getTime(inData) {
      return moment(inData.toString()).format("HH:mm");
    },
    getMonth() {
      return this.mjeseci[moment().month()];
    },
    getYear() {
      return moment().year();
    },
    goToPredmet(nastavak) {
      this.$router.push(nastavak);
    },
    getGroupById() {
      share
        .getById(this.accessToken, this.$route.params.uid)
        .then((response) => {
          this.group = response.data.groupDetail;
          this.owners = response.data.owners.value;
          this.members = response.data.members.value;
          this.files = response.data.files.value;
        });

      person
        .getMembers(this.accessToken, this.$route.params.uid)
        .then((response) => {
          this.members = response.data.value;
          this.isLoaded = true;
        });
    },
    async addNapomena() {
      if (this.napomena.napomena_text.trim() != "") {
        this.napomena.unio = this.$store.state.logged_in_user.uid;
        await predmet_hand
          .addPredmetNapomena(this.napomena, this.$route.params.uid)
          .then(async () => {
            this.napomena.napomena_text = "";
            this.new_napomena_open = false;
            await this.refreshNapomene();
          });
      } else {
        this.new_napomena_open = false;
      }
    },
    async refreshNapomene() {
      await predmet_hand
        .getPredmetNapomene(this.$route.params.uid)
        .then((resp) => {
          this.napomene = resp.data;
          this.napomene = this.napomene.reverse();
          this.calculatePageNumber();
          this.paginirajOdabrane();
        });
    },
    getOdvjetnik(na) {
      const od = this.odvjetnici.find((o) => o.odvjetnik.uid == na);
      console.log(od);
      return od != null ? od.odvjetnik.ime + " " + od.odvjetnik.prezime : "";
    },
    resetNoteDetails() {
      this.note = {
        details: "",
        unio: "",
      };
      this.temp_note = null;
      this.is_edit_mode = false;
      this.new_notes_open = false;
    },
    setEdit(na) {
      this.temp_note = na;
      this.note.note_text = na.details;
      this.is_edit_mode = true;
      this.new_notes_open = true;
    },
    deleteNote(na) {
      this.temp_note = na;
      this.delete_warning = true;
    },
    async deleteNoteDb() {
      console.log(this.temp_note);
      await predmet_hand
        .deleteNote(this.temp_note.uid)
        .then(() => {})
        .finally(() => {
          this.temp_note = null;
          this.delete_warning = false;
          this.refreshNotes();
        });
    },
    async addNote() {
      if (this.note.note_text.trim() != "") {
        this.note.unio = this.$store.state.logged_in_user.uid;
        await predmet_hand
          .addPredmetNote(this.note, this.$route.params.uid)
          .then(async () => {
            await this.refreshNotes();
          })
          .finally(() => {
            this.resetNoteDetails();
          });
      } else {
        this.new_notes_open = false;
      }
    },
    async editNote() {
      if (this.note.note_text.trim() != "") {
        this.note.unio = this.$store.state.logged_in_user.uid;
        await predmet_hand
          .editPredmetNote(this.note, this.temp_note.uid)
          .then(async () => {
            await this.refreshNotes();
          })
          .finally(() => {
            this.resetNoteDetails();
          });
      } else {
        this.new_notes_open = false;
      }
    },
    async refreshNotes() {
      await predmet_hand
        .getPredmetNotes(this.$route.params.uid)
        .then((resp) => {
          console.log(resp.data);
          this.notes = resp.data;
          this.calculatePageNumberNotes();
          this.paginirajOdabraneNotes();
        });
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken;
    this.fetching = true;
    await getCaseData(this.$route.params.uid)
      .then(async (response) => {
        let all_together = response;
        this.predmet_info = all_together;
        this.case_qa = all_together.client_portal_case_qa ? all_together.client_portal_case_qa : [];

        this.odvjetnik_nositelj = all_together.predmet_odvjetnik_connector.find(
          (odvjetnik_el) => odvjetnik_el.status_odvjetnik_predmet.id_status == 2
        );

        this.fiz_stranke = all_together.connect_fiz_stranka;
        this.prav_protustranke = all_together.prav_connect_protustranka;
        this.fiz_protustranke = all_together.connect_fiz_protustranka;
        this.prav_stranke = all_together.prav_connect_stranka;
        this.odvjetnici = all_together.predmet_odvjetnik_connector;
        this.institucije = all_together.connect_institucija_predmet;
        this.sluzbene_osobe = all_together.connect_sluzbena_osoba;
        this.case_log = all_together.case_log.reverse();
        this.rootSpisi = all_together.spis;

        let idx_nositelj = this.odvjetnici.indexOf(this.odvjetnik_nositelj);
        if (idx_nositelj > 0) {
          this.odvjetnici.splice(idx_nositelj, 1);
          this.odvjetnici.sort((a, b) => {
            return (
              a.status_odvjetnik_predmet.id_status -
              b.status_odvjetnik_predmet.id_status
            );
          });
          this.odvjetnici.unshift(this.odvjetnik_nositelj);
        }

        // Load avatars (cached in sessionStorage, no re-fetch on navigation)
        await avatarService.enrichWithAvatars(this.odvjetnici, 'odvjetnik');


        console.log("odvjetnici", this.odvjetnici);
        this.calculatePageNumberActivity();
        this.paginirajOdabraneActivity();
        await this.refreshNapomene();
        await this.refreshNotes();
      })
      .finally(() => {
        this.fetching = false;
      });
  },
  mounted() {
    setTimeout(this.openWordClient, 3500);
  },
};
</script>

<style></style>
